import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ForumMockService } from '../forum-mock.service';
import { ForumCommunity, ForumPost, VoteValue } from '../forum.types';

/**
 * Card de post estilo Reddit: coluna de voto vertical + conteúdo.
 * Usado na home e na página de comunidade.
 */
@Component({
  selector: 'app-forum-post-card',
  templateUrl: './forum-post-card.component.html',
  styleUrls: ['./forum-post-card.component.css'],
})
export class ForumPostCardComponent {
  @Input() post!: ForumPost;
  /** Quando true, esconde a pílula de comunidade (ex: dentro da página da comunidade). */
  @Input() hideCommunity = false;

  constructor(private forum: ForumMockService, private router: Router) {}

  get community(): ForumCommunity | undefined {
    return this.forum.getCommunityById(this.post.communityId);
  }

  vote(value: VoteValue, ev: Event): void {
    ev.stopPropagation();
    ev.preventDefault();
    this.forum.votePost(this.post, value);
  }

  toggleSave(ev: Event): void {
    ev.stopPropagation();
    ev.preventDefault();
    this.forum.toggleSave(this.post);
  }

  open(): void {
    this.router.navigate(['/forum/post', this.post.id]);
  }

  openCommunity(ev: Event): void {
    ev.stopPropagation();
    const c = this.community;
    if (c) {
      this.router.navigate(['/forum/c', c.slug]);
    }
  }

  /** Formata número grande: 1240 -> 1.2k */
  short(n: number): string {
    if (n >= 1000) {
      return (n / 1000).toFixed(1).replace('.0', '') + 'k';
    }
    return `${n}`;
  }
}
